import { type ImportOption } from './';

// Options for the import columns
export class ImportOptions<TRow> {
    options: Array<ImportOption>;
    constructor(options: Array<ImportOption>) {
        this.options = options;
    }
}
